import * as types from '@/store/mutation-types';

const mutations = {
  [types.UPDATE_CODE](state, p) {
    const drp = p.drp;
    drp.code = p.code;
  },
  [types.SET_CODE_HIDDEN](state, p) {
    const drp = p.drp;
    drp.hidden = p.hidden;
  },
};

const actions = {
  updateCode: ({ commit }, payload) => {
    commit(types.UPDATE_CODE, payload);
  },
  setCodeHidden: ({ commit }, payload) => {
    commit(types.SET_CODE_HIDDEN, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/code-general/vuex.js